import * as PIXI from "pixi.js";
import { average, dist } from "./utils";
export var LEFT = 0;
export var RIGHT = 1;
var FontAtlasTextGeometry = /** @class */ (function () {
    function FontAtlasTextGeometry() {
        this._vertexArray = [];
        this._uvArray = [];
        this._indexArray = [];
        this._glyph = [];
        this._glyphCenters = [];
        // why do we need this here?
        this.atlasResolution = 256; // atlas atlasResolution
    }
    FontAtlasTextGeometry.prototype.clear = function () {
        this._vertexArray = [];
        this._uvArray = [];
        this._indexArray = [];
        this._glyph = [];
        this._glyphCenters = [];
    };
    FontAtlasTextGeometry.prototype.moveGlyph = function (index, xOffset, yOffset) {
        var start = this._glyph[index].vertexRange[0];
        // x
        this._vertexArray[start] += xOffset;
        this._vertexArray[start + 2] += xOffset;
        this._vertexArray[start + 4] += xOffset;
        this._vertexArray[start + 6] += xOffset;
        // y
        this._vertexArray[start + 1] += yOffset;
        this._vertexArray[start + 3] += yOffset;
        this._vertexArray[start + 5] += yOffset;
        this._vertexArray[start + 7] += yOffset;
    };
    FontAtlasTextGeometry.prototype.containsGlyph = function (x, y, glyphRange) {
        for (var i = glyphRange.start; i <= glyphRange.end; i++) {
            if (this._containsGlyph(i, x, y)) {
                var edge = this._closestEdgeToGlyph(i, x);
                return [i, edge];
            }
        }
        return [-1, 0];
    };
    FontAtlasTextGeometry.prototype._closestEdgeToGlyph = function (index, x) {
        var vertexArray = this._getGlyphVertexArray(index);
        var x0 = vertexArray[4]; // left
        var x1 = vertexArray[0]; // right
        var left = x - x0;
        var right = x1 - x;
        return left < right ? LEFT : RIGHT;
    };
    FontAtlasTextGeometry.prototype._containsGlyph = function (index, x, y) {
        var vertexArray = this._getGlyphVertexArray(index);
        var x0 = vertexArray[4];
        var x1 = vertexArray[0];
        var y0 = vertexArray[5];
        var y1 = vertexArray[1];
        var width = x1 - x0;
        var height = y1 - y0;
        if (width <= 0 || height <= 0) {
            return false;
        }
        if (x >= x0 && x < x0 + width) {
            if (y >= y0 && y < y0 + height) {
                return true;
            }
        }
        return false;
    };
    // TODO: add a glyphRangeContains to speed up process
    // !!!TODO: use contain instead of closest
    FontAtlasTextGeometry.prototype.closestGlyph = function (x, y, glyphRange) {
        if (this._glyphCenters.length === 0) {
            this._cacheGlyphCenters();
        }
        var shortestDistance = Infinity;
        var index = -1;
        for (var i = glyphRange.start; i <= glyphRange.end; i++) {
            // @ts-ignore
            // if (PIXI.TextMetrics.isNewline(this._glyph[i].id)) {
            //     continue;
            // }
            var distance = dist(this._glyphCenters[i], { x: x, y: y });
            if (shortestDistance > distance) {
                shortestDistance = distance;
                index = i;
            }
        }
        var edge = LEFT;
        if (index !== -1) {
            edge = this._closestEdgeToGlyph(index, x);
        }
        return [index, edge];
    };
    FontAtlasTextGeometry.prototype.getGlyphCenter = function (index) {
        if (this._glyphCenters.length === 0) {
            this._cacheGlyphCenters();
        }
        return this._glyphCenters[index];
    };
    FontAtlasTextGeometry.prototype._cacheGlyphCenters = function () {
        for (var i = 0; i < this._glyph.length; i++) {
            this._glyphCenters.push(this._getGlyphCenter(i));
        }
    };
    // TODO: we need more information
    //  - to select the start and end of a word
    //  - to select spaces
    FontAtlasTextGeometry.prototype._getGlyphCenter = function (index) {
        var vertexArray = this._getGlyphVertexArray(index);
        var p1 = {
            x: vertexArray[4],
            y: vertexArray[5],
        };
        var p2 = {
            x: vertexArray[0],
            y: vertexArray[1],
        };
        return average(p1, p2);
    };
    FontAtlasTextGeometry.prototype.printGlyphBounds = function () {
        for (var i = 0; i < this._glyph.length; i++) {
            var bounds = this._getGlyphBounds(i);
        }
        console.log(JSON.stringify(this._vertexArray));
    };
    FontAtlasTextGeometry.prototype._getGlyphBounds = function (index) {
        if (typeof index !== "number") {
            throw Error("Invalid type ".concat(typeof index, " -- Expected number"));
        }
        if (!this._glyph[index]) {
            throw Error("Invalid glyph index ".concat(index, " -- max id = ").concat(this._glyph.length - 1));
        }
        var x1Index = this._glyph[index].vertexRange[0];
        var y1Index = this._glyph[index].vertexRange[0] + 1;
        var x0Index = this._glyph[index].vertexRange[0] + 4;
        var y0Index = this._glyph[index].vertexRange[0] + 5;
        var x1 = this._vertexArray[x1Index];
        var y1 = this._vertexArray[y1Index];
        var x0 = this._vertexArray[x0Index];
        var y0 = this._vertexArray[y0Index];
        var width = x1 - x0;
        var height = y1 - y0;
        var bounds = new PIXI.Rectangle(x0, y0, width, height);
        return bounds;
    };
    FontAtlasTextGeometry.prototype.getBounds = function (glyphIndexArray) {
        if (glyphIndexArray.length === 0) {
            return new PIXI.Rectangle();
        }
        var bounds = this._getGlyphBounds(glyphIndexArray[0]);
        for (var i = 1; i < glyphIndexArray.length; i++) {
            bounds.enlarge(this._getGlyphBounds(glyphIndexArray[i]));
        }
        return bounds;
    };
    FontAtlasTextGeometry.prototype.addWhitespace = function (id, width, height) {
        var metrics = {
            x: 0,
            y: 0,
            width: width,
            height: height,
            textureId: 0,
            advanceWidth: 0,
            advanceHeight: 0,
            leftBearing: 0,
            topBearing: 0,
        };
        return this.addGlyph(id, metrics);
    };
    FontAtlasTextGeometry.prototype.addGlyph = function (id, metrics, multi) {
        if (multi === void 0) { multi = 1; }
        var vertices = this._generateGlyphVertices(metrics, multi);
        // vertex order to create a triangle/polygon
        var indexOffset = this._glyph.length * 4;
        var indices = [
            indexOffset, 1 + indexOffset, 2 + indexOffset,
            2 + indexOffset, 3 + indexOffset, indexOffset,
        ];
        var uvs = this._generateGlyphUVs(metrics);
        this._vertexArray = this._vertexArray.concat(vertices);
        this._indexArray = this._indexArray.concat(indices);
        this._uvArray = this._uvArray.concat(uvs);
        var glyphIndex = this._glyph.length;
        var vertexStart = this._glyph.length * 8;
        var vertexEnd = ((this._glyph.length + 1) * 8) - 1;
        this._glyph.push({
            vertexRange: [vertexStart, vertexEnd],
            id: id
        });
        return glyphIndex;
    };
    Object.defineProperty(FontAtlasTextGeometry.prototype, "glyphCount", {
        get: function () {
            return this._glyph.length;
        },
        enumerable: false,
        configurable: true
    });
    FontAtlasTextGeometry.prototype._getGlyphVertexArray = function (index) {
        var _a;
        var vertexRange = (_a = this._glyph[index]) === null || _a === void 0 ? void 0 : _a.vertexRange;
        if (!vertexRange) {
            // throw Error(`Invalid index ${index} -- max ${this._glyph.length}`);
            return [];
        }
        var vertexArray = this._vertexArray.slice(vertexRange[0], vertexRange[1] + 1);
        return vertexArray;
    };
    FontAtlasTextGeometry.prototype._generateGlyphVertices = function (metrics, multi) {
        var x0 = (0 + metrics.leftBearing) * multi;
        var x1 = (metrics.width + metrics.leftBearing) * multi;
        var y0 = (0 + metrics.topBearing) * multi;
        var y1 = (metrics.height + metrics.topBearing) * multi;
        return [
            x1, y1,
            x1, y0,
            x0, y0,
            x0, y1,
        ];
    };
    FontAtlasTextGeometry.prototype._generateGlyphUVs = function (metrics) {
        var x0 = metrics.x / this.atlasResolution;
        var x1 = (metrics.x + metrics.width) / this.atlasResolution;
        var y0 = (-metrics.y - metrics.height) / this.atlasResolution;
        var y1 = (-metrics.y) / this.atlasResolution;
        var glyphUVs = [
            x1, y1,
            x1, y0,
            x0, y0,
            x0, y1,
        ];
        return glyphUVs;
    };
    FontAtlasTextGeometry.prototype.build = function () {
        var geometry = new PIXI.Geometry();
        geometry.addAttribute('aVertexPosition', this._vertexArray, 2);
        geometry.addAttribute('aUvs', this._uvArray, 2);
        geometry.addIndex(this._indexArray);
        return geometry;
    };
    FontAtlasTextGeometry.prototype.buildBounds = function () {
        var bounds = new PIXI.Bounds;
        bounds.addVertexData(this._vertexArray, 0, this._vertexArray.length);
        return bounds;
    };
    return FontAtlasTextGeometry;
}());
export { FontAtlasTextGeometry };
